import axios from 'axios'
import Utils from '@/services/utils'

/// //////////////////////////////////////////////
// Init AXIOS
/// //////////////////////////////////////////////
let successCallback = null
let errorCallback = null

/**
 * @returns {string}
 */
const getApiBaseUrl = () => {
  // Local development env variable (only)
  let baseUrl = process.env.VUE_APP_RENDER_FARM_MASTER_URL

  if (!baseUrl) {
    baseUrl = `https://${
      process.env.VUE_APP_RENDERS_API_SUBDOMAIN
    }.${Utils.getAppDomain()}/`
  }

  return Utils.processBaseUrl(baseUrl)
}

const HTTPRenderFarmMaster = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Stitch-Client': 'Boards-FE'
  },
  withCredentials: true
})

HTTPRenderFarmMaster.interceptors.response.use(
  response => {
    if (successCallback) {
      successCallback(response)
    }

    return response
  },
  error => {
    if (errorCallback) {
      errorCallback(error)
    }

    return Promise.reject(error)
  }
)

/**
 * @param {object} parameters
 */
const setCallbacks = parameters => {
  successCallback = parameters.successCallback
  errorCallback = parameters.errorCallback
}

/// //////////////////////////////////////////////
// JOBS
/// //////////////////////////////////////////////

/**
 * @param   {number}       jobId
 *
 * @returns {AxiosPromise}
 */
const fetchJobDetail = async jobId => {
  const response = await HTTPRenderFarmMaster.get(
    `/jobs/${jobId}/?preview&include-task-files`
  )

  return response.data
}

/**
 * @param   {number}       offset
 * @param   {number}       limit
 * @param   {string}       searchQuery
 *
 * @returns {AxiosPromise}
 */
const fetchJobs = async (offset, limit, searchQuery) => {
  const url = '/jobs/?preview'
  try {
    const response = await HTTPRenderFarmMaster.get(url, {
      params: {
        type: 'dh-blend-file-task,render-fbx-zip,dh-render-vsp-user',
        name: searchQuery,
        offset,
        limit
      }
    })

    return response.data.results
  } catch (error) {
    // User is not logged in on DH
    if (error.response && error.response.status === 403) {
      return false
    }

    throw error
  }
}

/// //////////////////////////////////////////////
// Object Building
/// //////////////////////////////////////////////

const jobsCalls = {
  fetchJobDetail,
  fetchJobs
}

const RenderFarmMasterAPI = {
  getApiBaseUrl,
  setCallbacks,
  ...jobsCalls
}

export default RenderFarmMasterAPI
